
/* eslint-disable */
import { Component, Vue } from 'nuxt-property-decorator'
import { email, required } from 'vuelidate/lib/validators'
import axios from 'axios'
import FileInput from '~/components/FileInput.vue'

interface Country {
  code: string
  country: string
}

@Component({
  components: { FileInput },
  // isInOrganization: { required: ['artist', 'artCritic', 'curator'].includes(this.type) && required }, // artist, critic, curator
  // linkPhoto: { required: ['artCritic', 'artist', 'curator'].includes(this.type) && required }, // artist, critic, curator
  // linkWork: { required: this.type === 'artist' && required }, // artist
  // linkPublish: { required: ['artCritic', 'curator'].includes(this.type) && required }, // critic, curator
  // nameGallery: { required: this.type === 'gallery' && required }, // gallery
  // linkLogotype: { required: ['gallery', 'showroom', 'business'].includes(this.type) && required }, // gallery, showroom, business
  // linkSite: { required: ['gallery', 'showroom', 'business'].includes(this.type) && required }, // gallery, showroom, business
  // nameShowRoom: { required: this.type === 'showroom' && required }, // showroom
  // nameCompany: { required: this.type === 'business' && required } // business
  validations () {
  return {
  formData: {
  name: { required },
  country: {},
  email: { required, email },
  phone: {},
  facebook: {},
  instagram: {},
  photo: {},
  main_artwork: { required },
  manifesto: {}
  }
  }
  }
  })
export default class extends Vue {
  btnDisabled: boolean = false
  countryOptions: Country[] = require('~/assets/countries.json')

  formData: any = {
    name: '',
    country: '',
    email: '',
    phone: '',
    facebook: '',
    instagram: '',
    photo: '',
    main_artwork: '',
    manifesto: ''
  }

  sizeError = {
    photo: false,
    main_artwork: false,
  }

  handleWithErr (key, value) {
    this.formData[key] = value;
    this.sizeError[key] = false
  }

  onSubmit () {
    this.$v.$touch()

    if (this.$v.$error) {
      return
    }

    const formData = new FormData()
    for (const key in this.formData) {
      formData.append(key, this.formData[key])
    }

    this.btnDisabled = true
    axios.post(process.env.API_ENDPOINT + '/api/v3/sandbox-artists/join', formData).then(() => {
      this.btnDisabled = false
      this.$emit('next')
    }).catch(() => {
      this.btnDisabled = false
    })
  }
}
